
import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/home/Hero';
import ClientEngagements from '../components/home/ClientEngagements';
import ServiceOverview from '../components/home/ServiceOverview';
import ProjectsShowcase from '../components/home/ProjectsShowcase';
import Testimonials from '../components/home/Testimonials';
import TechStack from '../components/home/TechStack';
import ContactCTA from '../components/home/ContactCTA';

const Index = () => {
  return (
    <Layout>
      <Hero />
      <ClientEngagements />
      <ServiceOverview />
      <ProjectsShowcase />
      <Testimonials />
      <TechStack />
      <ContactCTA />
    </Layout>
  );
};

export default Index;
